import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Visible breadcrumb trail.
 *
 * Use alongside `buildBreadcrumbSchema(...)` so search engines and AI
 * crawlers see the same hierarchy in the JSON-LD as they do in the
 * rendered DOM.
 *
 * `items` is an ordered array of `{ name, to }` — the LAST item is the
 * current page (rendered as plain text, not a link).
 */
export default function Breadcrumb({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-[#5C665D]"
      data-testid="breadcrumb"
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.name}-${i}`} className="flex items-center gap-1.5">
            {isLast ? (
              <span
                className="text-[#1F382E]"
                aria-current="page"
                data-testid={`breadcrumb-current`}
              >
                {item.name}
              </span>
            ) : (
              <Link
                to={item.to}
                className="hover:text-[#1F382E] transition-colors"
                data-testid={`breadcrumb-link-${i}`}
              >
                {item.name}
              </Link>
            )}
            {!isLast && (
              <ChevronRight
                size={11}
                strokeWidth={1.5}
                className="text-[#C1B9A8]"
                aria-hidden="true"
              />
            )}
          </span>
        );
      })}
    </nav>
  );
}
